var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "home" },
    [
      _c("Cheader"),
      _c("div", { staticClass: "formBox" }, [
        _c("div", { staticClass: "bg" }, [
          _vm._m(0),
          _c("div", { staticClass: "form-login" }, [_c("Login")], 1),
        ]),
      ]),
      _c("Contents"),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _c("div", [_vm._v("江西省2025年高等职业教育单独招生")]),
      _c("div", { staticClass: "font" }, [_vm._v("模拟练习平台")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }